import { datadogRum } from "@datadog/browser-rum";

const configsPerEnv = {
  development: {
    sessionReplaySampleRate: 0,
  },
  staging: {
    sessionReplaySampleRate: 0,
  },
  production: {
    sessionReplaySampleRate: 1,
  },
};

export const initDatadog = () => {
  const env = process.env.NODE_ENV || "development";

  // Only initialize in production
  if (env !== "production") {
    return;
  }

  const config = configsPerEnv[env];

  datadogRum.init({
    applicationId: process.env.DATADOG_APPLICATION_ID,
    clientToken: process.env.DATADOG_CLIENT_TOKEN,
    site: "datadoghq.com",
    service: "control-panel",
    env: env,
    version: "1.0.0",
    sessionSampleRate: 10,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    enableExperimentalFeatures: ["feature_flags"],
    ...config,
  });

  datadogRum.startSessionReplayRecording();
};
